import React, { useState } from 'react';
import { Prompt } from 'react-router-dom';
import Modal from '../Modal';

const ConfirmLeaveModal = ({
  skipNavigationControl = () => false,
  navigate,
  when = true,
  children,
  title,
  acceptLabel,
  onAccept,
}) => {
  const [open, setOpen] = useState(false);
  const [nextLocation, setNextLocation] = useState('');

  const handleWarnNavigation = location => {
    if (open || skipNavigationControl()) {
      setOpen(false);
      return true;
    }
    setNextLocation(location);
    setOpen(true);
    return false;
  };

  return (
    <>
      <Prompt when={when} message={handleWarnNavigation} />
      {open && (
        <Modal
          data-blocoid="Modal: Voltar"
          showFooter
          title={title}
          acceptLabel={acceptLabel}
          onReject={() => setOpen(false)}
          onAccept={() => {
            if (onAccept) {
              onAccept();
            }
            navigate(nextLocation);
          }}
        >
          {children}
        </Modal>
      )}
    </>
  );
};

export default ConfirmLeaveModal;
